<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">合同管理</span>
                <el-row>
                  <el-col :span="5">
                    <el-input placeholder="合同名称" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchCondition.keyWord"
                      @change="onSearchConditionChanged">
                    </el-input>
                  </el-col>
                  <el-col :span="5" v-if="hasContractTypeFilter">
                    <el-select multiple placeholder="合同类型" v-model="searchCondition.contractTypes" @change="onSearchConditionChanged" size="medium"
                      class="margin-left-20px">
                      <el-option v-for="item in contractTypeOptions" :key="item.value" :label="item.desc"
                        :value="item.value" />
                    </el-select>
                  </el-col>
                  <el-col :span="10">
                    <el-button type="primary" :disabled="loading" size="medium" class="margin-left-20px" @click="onSearchClick">搜索</el-button>
                    <el-button v-if="!isReadonly" type="primary" :disabled="loading" class="margin-left-20px" size="medium" @click="onAddClick">添加</el-button>
                  </el-col>
                </el-row>
                <pagination v-loading="loading" :data="pageData" :option="paginationOption" @loadData="onPaginationLoadData" @edit="onPaginationEdit">
                  <template #ContractType="{col, row}">
                    <span>{{GLOBAL.contractType.getDesc(row[col.Name])}}</span>
                  </template>
                  <template #Enable="{col, row}">
                    <span>{{row[col.Name] ? "启用" : "禁用"}}</span>
                  </template>
                  <template #Files="{col, row}">
                    <div v-if="row[col.Name].length > 0">
                      <div v-for="item in row[col.Name]" :key="item.Id">{{item.FileStorageName}}</div>
                    </div>
                    <div v-else />
                  </template>
                </pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <contractEditor key="contractEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="isReadonly" :data="editorData" @change="onContractEditorChange" />
  </div>
</template>

<script>
import { getContractPageData } from "@/service/contract.service";

export default {
  name: "contractList",
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
    contractEditor: () => import("@/components/contract/contractEditor"),
  },
  data() {
    return {
      loading: false,
      hasContractTypeFilter: true,
      contractTypeOptions:[],
      searchCondition: {
        pageSize: 20,
        pageNumber: 1,
        sortField: null,
        isDesc: false,
        keyWord: "",
        contractTypes: [],
      },
      paginationOption: {
        displayPagination: true,
        hasEditButton: true,
        hasAddButton: false,
        hasSearch: false,
        hasDeleteButton: false,
        additionalColumns: [],
        fnCustomRowClass(row) {
          if (row.Enable) return null;

          return "disabled-row";
        },
        fnCustomCellClass(col, row) {
          return {
            "color-label": col.IsColorLabel,
          };
        },
      },
      pageData: {},
      editorData: null,
    };
  },
  created() {
    this.paginationOption.hasEditButton = !this.isReadonly;
    let options = this.GLOBAL.contractType.getOptions();
 
    if (!this.USERMANAGER.isVocationalTrainingManager){
      options = options.filter(i => i.value !== 0);
    }else{
      options = options.filter(i => i.value === this.GLOBAL.contractType.vocationalTraining);
      this.searchCondition.contractTypes = [this.GLOBAL.contractType.vocationalTraining];
      this.hasContractTypeFilter = false;
    }
    this.contractTypeOptions = options;

    this.search();
  },
  computed: {
    isReadonly() {
      return !(this.USERMANAGER.isAdmin || this.USERMANAGER.isCampusPresident 
        || this.USERMANAGER.isExecutiveManager || this.USERMANAGER.isVocationalTrainingManager);
    }
  },
  methods: {
    async loadContractPageDataFromServer() {
      this.loading = true;
      try {
        let condition = {
          PageSize: this.searchCondition.pageSize,
          PageNumber: this.searchCondition.pageNumber,
          SortField: this.searchCondition.sortField,
          IsDesc: this.searchCondition.isDesc,
          KeyWord: this.searchCondition.keyWord,
          AdditionalFilter: {
            ContractTypes: this.searchCondition.contractTypes,
          },
        };
        let result = await getContractPageData(condition);
        if (!!result && result.success) {
          this.searchCondition.pageNumber = result.data.CurrentPage;
          this.pageData = result.data;
        } else {
          this.searchCondition.pageNumber = 1;
          this.pageData = [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    search() {
      this.loadContractPageDataFromServer();
    },
    onSearchConditionChanged() {
      //this.search();
    },
    onSearchClick() {
      this.search();
    },
    openContractEditor() {
      let contractEditor = this.$vueRefStore.getChildrenRef("contractEditor");
      if (!contractEditor) return;

      contractEditor.showDialog();
    },
    closeContractEditor() {
      let contractEditor = this.$vueRefStore.getChildrenRef("contractEditor");
      if (!contractEditor) return;

      contractEditor.closeDialog();
    },
    onAddClick() {
      this.editorData = null;
      this.openContractEditor();
    },
    onPaginationLoadData(pageData) {
      let keyWord = this.searchCondition.keyWord;
      Object.copy(this.searchCondition, pageData);
      this.searchCondition.keyWord = keyWord;

      this.search();
    },
    onPaginationEdit(index, row) {
      this.editorData = row;
      this.openContractEditor();
    },
    onContractEditorChange() {
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/admin/contractList.vue